import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ModalComponent } from '@ui-kit/miscs';

@Component({
    selector: 'unsaved-changes-modal',
    templateUrl: './unsaved-changes-modal.component.html',
    styleUrls: ['./unsaved-changes-modal.component.scss'],
    imports: [TranslateModule, ModalComponent],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnsavedChangesModalComponent {
    isVisible = model.required<boolean>();
    unsavedChangesModalScopeText = input.required<string>();

    onClose = output<void>();
    leavePage = output<void>();
}
